import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpEventType} from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import {distinctUntilChanged, tap} from 'rxjs/operators';
import { SpinnerService } from './spinner.service';



@Injectable()
export class HttpSpinnerInterceptor implements HttpInterceptor {

  constructor(private SPINNER: SpinnerService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Initialement, je pensais qu'on pouvait afficher le spinner avant interception de la requête,
    // mais cela ne marche pas comme attendu. Le service est bien appelé, mais cela ne déclenche pas
    // de mise à jour (change detection) au niveau du composant.
    // Pour gérer l'affichage du spinner, on passe donc par l'option "reportProgress", qui permet d'avoir
    // accès à différentes étapes du cycle de vie de la requête.
    // REF : https://stackoverflow.com/a/45515627/5751783
    //       https://alligator.io/angular/httpclient-intro/
    //       https://netbasal.com/a-taste-from-the-new-angular-http-client-38fcdc6b359b
    // this.SPINNER.showSpinner();

    // On clone la requête d'origine en ajoutant  "reportProgress", qui nous sert à surveiller
    // l'avancement de la requête pour afficher
    // ou masquer le spinner.
    const cloneRequete = req.clone({reportProgress: true});
    // Et on utilise ce clone à la place de la requête d'origine, tout en masquant surveillant
    // certaines étapes pour afficher/masquer le spinner selon l'étape où se trouve la requête.
    return next.handle(cloneRequete)
    // Sans le distinct, se déclenche 2fois sur FF (mais pas sur Chrome)
    .pipe(distinctUntilChanged(), tap(event => {
        // On gère l'affichage du spinner, matérialisant un échange en cours avec le serveur
        if (event.type === HttpEventType.Sent) {
          this.SPINNER.showSpinner(cloneRequete.url);
        } else if (event.type === HttpEventType.Response
              || (event.type === HttpEventType.ResponseHeader  && (event.status === 0 || event.status >= 400) )) {
          this.SPINNER.hideSpinner(cloneRequete.url);
        } else {
          // console.log(event);
        }

        // En parallèle, on gère le cas d'une erreur d'authentification (réponse 401 du serveur à une requête)
        // NOTE : en raison d'un bug sur Firefox (pas trouvé de référence malheureusement), on passe plusieurs
        // fois dans ce code au lieu de n'y passer qu'une fois. En conséquence, la popup de confirmation s'affichait
        // deux fois d'affilée. Pour résoudre le problème, il a fallu ajouter le distinctUntilChanged() ci-dessus
        if (event.type === HttpEventType.ResponseHeader) {
          if (event.status === 401 && this.router.routerState.snapshot.url !== '/authentification') {
            if (confirm(
`Votre session a expirée, probablement suite à un redémarrage du serveur.
  Vous ne pouvez pas enregistrer de saisie tant que vous ne vous serez pas authentifié à nouveau.

Vous pouvez cliquer sur 'OK' pour retourner à la page d'authentification
  ou
sur 'Annuler' pour utiliser la fonction [Reprendre plus tard] afin de ne pas perdre votre saisie.`
            )) {
              this.router.navigate(['/authentification']);
            }
          }

          // Idée initiale : afficher une alert lorsque que le serveur est HS. Mais dans les faits,
          // je n'ai pas réussi à trouver une condition permettant d'identifier exactement ce cas de
          // figure ; le test envisagé initialement (status=0) affiche également la popup lors d'un
          // simple F5 sur la page. Des tentatives autour de l'objet window.performance.navigation n'ont pas aidé.
          // En conséquence, on ne déclenche l'alerte qu'après un timeout, de façon à éliminer les rechargements
          // (le contexte de la page étant rechargé avant affichage de l'alert, celle-ci n'est jamais montrée.)
          if (event.type === HttpEventType.ResponseHeader && event.status === 0) {
            // alert('Le serveur semble indisponible, merci de contacter la maintenance. type='+window.performance.navigation.type);
            setTimeout( (_) => alert('Le serveur semble indisponible, merci de contacter la maintenance.'), 50);
            // this.SPINNER.hideSpinner();
          }

          // Gestion des erreurs dues au reverse proxy
          if (event.status === 503) {
            setTimeout((_) => alert('Le serveur semble indisponible, merci de contacter la maintenance.'), 50);
          }
        }
      }, error => {
        //console.error(error);
        console.log(error); 
        this.SPINNER.hideSpinner(cloneRequete.url);
      }
      ));
  }
}
